import styled from 'styled-components';

import { NewIcon } from '@/assets/static/icons/todo-page/new';
import { OlderIcon } from '@/assets/static/icons/todo-page/older';
import { useResponsive } from '@/hooks/use-responsive';
import { themeVar } from '@/styles/theme';
import React from 'react';
import { Line, statusNextStepRelations } from './todo-list';

export interface AssignedToMe {
  id?: string;
  new: number;
  old: number;
  status: string;
  total: number;
}

export interface OwnedByMeNotAssignedToMe {
  id?: string;
  new: number;
  old: number;
  status: string;
  total: number;
}

interface CardProps {
  data: {
    assignedToMe: AssignedToMe[];
    ownedByMeNotAssignedToMe: OwnedByMeNotAssignedToMe[];
  };
  onRedirect: ({ id, name }: { id: string; name: string }) => void;
}

export const AssignedToMeItem = ({ data, onRedirect }: CardProps) => {
  const { isMobile } = useResponsive();

  return (
    <SubItemWrap>
      {data?.assignedToMe?.map((assigned) => (
        <React.Fragment key={assigned?.id || assigned?.status}>
          {assigned.total > 0 ? (
            <StatusWrap
              onClick={() => {
                onRedirect({ id: assigned?.id, name: assigned?.status });
              }}
              // onMouseEnter={() => setTab(assigned.status)}
            >
              <StatusCount>{assigned.total}</StatusCount>
              <StatusTitle>{statusNextStepRelations[assigned.status as keyof typeof statusNextStepRelations] || assigned.status}</StatusTitle>
            </StatusWrap>
          ) : null}

          {assigned.new > 0 ? (
            <CounterWrap
              onClick={() => {
                onRedirect({ id: assigned?.id, name: assigned?.status });
              }}
              // onMouseEnter={() => setTab(assigned.status)}
            >
              <NewIcon width={26.5} height={24} />
              <CounterTitle color={themeVar('context.success')}>{assigned.new}</CounterTitle>
            </CounterWrap>
          ) : null}

          {assigned.old > 0 ? (
            <CounterWrap
              onClick={() => {
                onRedirect({ id: assigned?.id, name: assigned?.status });
              }}
              // onMouseEnter={() => setTab(assigned.status)}
            >
              <OlderIcon width={26.5} height={24} />
              <CounterTitle color={themeVar('context.warning')}>{assigned.old}</CounterTitle>
            </CounterWrap>
          ) : null}
          {assigned.total > 0 || assigned.new > 0 || assigned.old > 0 ? <Line $isMobile={isMobile} /> : null}
        </React.Fragment>
      ))}
    </SubItemWrap>
  );
};

export const OwnedByMeItem = ({ data, onRedirect }: CardProps) => {
  const { isMobile } = useResponsive();

  return (
    <SubItemWrap>
      {data?.ownedByMeNotAssignedToMe?.map((owned) => (
        <React.Fragment key={owned?.id || owned?.status}>
          {owned.total > 0 ? (
            <StatusWrap
              onClick={() => {
                onRedirect({ id: owned?.id, name: owned?.status });
              }}
              // onMouseEnter={() => setTab(owned.status)}
            >
              <StatusCount>{owned.total}</StatusCount>
              <StatusTitle>{statusNextStepRelations[owned.status as keyof typeof statusNextStepRelations] || owned.status}</StatusTitle>
            </StatusWrap>
          ) : null}

          {owned.new > 0 ? (
            <CounterWrap
              onClick={() => {
                onRedirect({ id: owned?.id, name: owned?.status });
              }}
              // onMouseEnter={() => setTab(owned.status)}
            >
              <NewIcon width={26.5} height={24} />
              <CounterTitle color={themeVar('context.success')}>{owned.new}</CounterTitle>
            </CounterWrap>
          ) : null}

          {owned.old > 0 ? (
            <CounterWrap
              onClick={() => {
                onRedirect({ id: owned?.id, name: owned?.status });
              }}
              // onMouseEnter={() => setTab(owned.status)}
            >
              <OlderIcon width={26.5} height={24} />
              <CounterTitle color={themeVar('context.warning')}>{owned.old}</CounterTitle>
            </CounterWrap>
          ) : null}
          {owned.total > 0 || owned.new > 0 || owned.old > 0 ? <Line $isMobile={isMobile} /> : null}
        </React.Fragment>
      ))}
    </SubItemWrap>
  );
};

const SubItemWrap = styled.div`
  display: flex;
  gap: 12px;
  cursor: pointer;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
`;

const StatusWrap = styled.div`
  display: flex;
  align-items: center;
`;

const CounterWrap = styled.div`
  align-items: center;

  display: flex;
  gap: 6px;
`;

const StatusCount = styled.div`
  font-family: Blinker, serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0;
  color: ${themeVar('font.action')};
  margin-right: 4px;
`;

const StatusTitle = styled.div`
  font-family: Blinker, serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0;
  color: ${themeVar('font.action')};
`;

const CounterTitle = styled.div<{ color: string }>`
  font-family: Blinker, serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0;
  color: ${({ color }) => color};
`;
